import type { State } from '~/store';


export function selectIsWorkflowLockOwnedByAgent(state: State) {
  return state.workflowEditor.locking.isLoggedInAgentOwner;
}

export function selectWorkflowLockingData(state: State) {
  return state.workflowEditor.locking;
}
